import { APIClient } from "api/api_helper";
import { GetUserData, CurrentUser } from "common/service/CommonService";
import { DISPOSAL_API } from "api/url_helper";

const api = new APIClient();

export const disposalApiService = {

  // SELECT ALL
  getSelectAllData: (params: any) => {
    return api.create(DISPOSAL_API.DISPOSAL_API + "SelectAll", params);
  },

  // SELECT BY ID
  getSelectData: (id: number | string) => {
    return api.create(DISPOSAL_API.DISPOSAL_API + "Select", { disposalid: id });
  },

  verifyPin: (payload: { verifypin: string, disposalid: number, studyid: number, verifiedby: number }) => {
    return api.create(DISPOSAL_API.DISPOSAL_API + "Verify", payload);
  },

  // INSERT
  insertData: (payload_data: any) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      ...payload_data,
      createdby: user.userid,
    };

    return api.create(DISPOSAL_API.DISPOSAL_API + "Insert", payload);
  },

  // UPDATE
  updateData: (payload_data: any) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      ...payload_data,
      updatedby: user.userid,
    };
    return api.create(DISPOSAL_API.DISPOSAL_API + "Update", payload);
  },

  // DELETE
  deleteData: (payload_data: { disposalid: number | null; updatereason: string; }) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      disposalid: payload_data.disposalid,
      updatereason: payload_data.updatereason,
      updatedby: user.userid,
    };
    return api.create(DISPOSAL_API.DISPOSAL_API + "Delete", payload);
  },
};
